import type { ReactNode } from 'react';
import { Box } from '@mantine/core';
import { SectionDivider } from '@/components/SectionDivider';

/** One switchable part of a report page: its divider and its content, kept together in print. */
export function Section({ title, className, children }: { title: string; className?: string; children: ReactNode }) {
  return (
    <Box component="section" className={['report-section', className].filter(Boolean).join(' ')}>
      <SectionDivider label={title} />
      {children}
    </Box>
  );
}
